const ieInjector = () => {
  document.getElementById('app').innerHTML =
    '<div class="error-page">' +
    '  <h1>Book de visite</h1>' +
    '  <p>Internet Explorer n\'est pas supporté. Essayez d\'ouvrir cette page dans Firefox, Chrome ou Edge.</p>' +
    '</div>';
};

export default ieInjector;



// WEBPACK FOOTER //
// ./book/src/commons/components/ieInjector.js